import { render, staticRenderFns } from "./RecipeLabelTime.vue?vue&type=template&id=ecd38fde&"
import script from "./RecipeLabelTime.vue?vue&type=script&lang=js&"
export * from "./RecipeLabelTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports